

import React, { useContext, useEffect, useState } from "react";



import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";



function AddressAmendmentLLP() {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };

  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);
  // if (loading) {
  //   return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //    return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = Array.isArray(services) ? services.find(s => s.service_id === 37) : null;

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }


    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };




  // const formPutPartenshipdeed = async (e) => {
  //   e.preventDefault();

  //   // ✅ Check if user is logged in
  //   // if (!token) {
  //   //   alert("Please log in to continue.");
  //   //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
  //   //   navigate('/login'); // 👈 Use this if you're using React Router
  //   //   return;
  //   // }
  //   if (!validateForm()) return;

  //    localStorage.setItem("bookingData", JSON.stringify(newData));

  //     // Navigate to checkout
  //     navigate('/checkout', {
  //        state: {
  //           service: service,

  //        }
  //     });

  // };

      const formPutPartenshipdeed = async (e) => {
        e.preventDefault();
    
        if (!validateForm()) return;
    
        try {
            const response = await PartenerSheepDeedService.addressAmendmentLLP(newData);
    
            console.log("API Success:", response);
    
            navigate("/thankyou");
    
            // Optional: reset form
            setNewData(prev => {
  const resetObj = {};
  Object.keys(prev).forEach(key => (resetObj[key] = ""));
  return resetObj;
});
    
    
        } catch (error) {
            console.error("API Error:", error);
            alert("Something went wrong!");
        }
    };


 const faqList = [
  {
    question: "Why is it important to update the registered address of an LLP within the same state in India?",
    answer: "Updating your LLP’s address ensures compliance with statutory regulations and helps maintain accurate records with the Ministry of Corporate Affairs (MCA) and other relevant authorities."
  },
  {
    question: "What documents are needed for changing the registered address?",
    answer: "To initiate the process, you’ll typically need to file LLP Form 3 (used for updating LLP agreements) along with valid proof of the new address—such as a recent utility bill, property tax receipt, or rent agreement."
  },
  {
    question: "Is partner consent mandatory for updating the LLP address?",
    answer: "Yes, if the address change alters any part of the LLP agreement, partners' approval is generally required. This can be done through a formal resolution or by signing the amended agreement."
  },
  {
    question: "How do I file for an address change with the authorities?",
    answer: "You must submit LLP Form 3, along with supporting documents, to the Registrar of Companies (RoC) that governs your LLP’s state of registration."
  },
  {
    question: "Are there any government fees for this amendment?",
    answer: "Yes, the fee depends on your LLP’s contribution amount. The latest fee structure is available on the MCA portal, or you may contact the RoC for precise details."
  },
  {
    question: "How long does the entire process usually take?",
    answer: "Processing time can vary based on the RoC's workload and the completeness of your submission. Typically, it ranges from a few working days to a couple of weeks."
  },
  {
    question: "What happens after the new address is approved?",
    answer: "Once approved, the Registrar will officially update the address in MCA records, ensuring that all government communication is sent to the new location."
  },
  {
    question: "Can I move the LLP to any address within the same state?",
    answer: "Yes, you’re free to update the LLP’s address to any valid and accessible location within the same state of incorporation."
  },
  {
    question: "What are the consequences of not updating the address?",
    answer: "Failure to amend the address can lead to penalties, non-compliance notices, and missed government correspondence, which may impact your LLP’s standing."
  },
  {
    question: "Can DM2Legal assist me with this process?",
    answer: "Absolutely! At DM2Legal, we recommend working with experienced professionals like a chartered accountant or company secretary. Our team can handle the entire process—ensuring compliance, preparing documentation, and making the update seamless for you."
  }
];

const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};



  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>

                <h1 className="sk-text-color">LLP Address Amendment (within State)</h1>

                <p className="pdrl-text">Get LLP Address Amendment (within State) for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Govt fees and Stamp Duty extra as applicable) </span></p>
                <p className="pd-text">With DM2Legal, you can be confident that your address amendment will be managed smoothly, so you can concentrate on growing your business.</p>

                               <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now</h3>         <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Govt fees and Stamp Duty extra as applicable) </span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">


            <div className="col-lg-12">

              {/* <h2>Annual Compliance LLP </h2> */}


              <p className="pd-text">Are you planning to update the registered address of your Limited Liability Partnership (LLP) within India? DM2Legal is here to provide you with a smooth and hassle-free LLP address amendment service. Our skilled team will guide you step-by-step, ensuring all legal formalities are properly met.

                We take care of the entire process, including preparing all necessary documentation such as LLP Form 3 and the proof of your new address. Once you share the required details, we will promptly file the application with the Registrar of Companies (RoC) on your behalf.

                Our experts make sure your submission is thorough and accurate to help secure quick approval. If the address change impacts your LLP agreement, we’ll also support you in obtaining the partners’ consent.

                With DM2Legal handling your LLP address update, you can rest assured the process will be efficient and compliant, so you can concentrate on growing your business. Reach out to us today for a trusted and professional LLP address amendment service within India.

              </p>
            </div>

          </div>


        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Address-Amendment-Within-state-(LLP).png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate text-center">Benefits </h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon1.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Stay Legally Compliant</a></h4>
        <p className="font-f-7">Keeping your LLP’s registered address up to date ensures you remain in line with the regulations issued by the Ministry of Corporate Affairs (MCA). It helps maintain accurate official records and demonstrates your adherence to legal norms.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon2.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Avoid Unnecessary Penalties</a></h4>
        <p className="font-f-7">Timely address updates can help you avoid fines, notices, or legal issues that may result from non-compliance with MCA requirements.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon3.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Preserve Your Business Reputation</a></h4>
        <p className="font-f-7">An up-to-date address shows your dedication to good governance and business transparency. It reinforces your LLP’s image as a credible and well-managed entity.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon5.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Ensure Smooth Government Communication</a></h4>
        <p className="font-f-7">With a current address on file, you won’t miss important communications from the Registrar of Companies (RoC) or other government bodies, minimizing delays and confusion.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon6.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Enhance Accessibility for Clients & Partners</a></h4>
        <p className="font-f-7">Having the correct address publicly listed ensures that your clients, vendors, and stakeholders can easily reach you—supporting better communication and smoother business dealings.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon4.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Enable Hassle-Free Banking & Finance Operations</a></h4>
        <p className="font-f-7">Banks and financial institutions rely on accurate business records for verifications. A correct address ensures uninterrupted services such as banking, credit applications, and other financial processes.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/brand6-4.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Simplify Tax Filings and Compliance</a></h4>
        <p className="font-f-7">An updated address makes it easier for tax authorities to send you essential documents like tax notices, assessments, and correspondence, keeping your tax matters in order.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/work6-icon3.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Support Continuous Operations</a></h4>
        <p className="font-f-7">Updating your LLP’s address helps avoid disruptions in business due to outdated information. It’s a simple step that protects your operations from potential legal or administrative setbacks.</p>
      </div>
    </div>
  </div>

</div>

          <div className="space20"></div>
        </div>
      </div>

      <div className="service-binifits9 sp0" id="service2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Online Registration Procedure </h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li>
                    <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>DM2Legal ensures your documents are thoroughly reviewed to avoid any errors or misleading information.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our experts assist with all documentation and licensing requirements.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Once your amendment form and supporting documents are ready, we’ll notify you.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>After submission and fee payment, please allow time for regulatory approval.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>We’ll share the official confirmation once your new registered office address is approved.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                    <div className="space30"></div>
                    <div id="general">


                      {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      < WhatsAppScrollButton />

      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default AddressAmendmentLLP;